module.exports = __webpack_public_path__ + "static/img/increment01.7d45e7b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wap/increment01.png
// module id = iwV3
// module chunks = 0